import { render, staticRenderFns } from "./OicListDetail.vue?vue&type=template&id=e6359402&scoped=true&"
import script from "./OicListDetail.vue?vue&type=script&lang=js&"
export * from "./OicListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6359402",
  null
  
)

export default component.exports